import {
    getSavedState,
    saveState,
    removeState,
} from '@src/utils/localStorage.js'
import {
    LogInService,
    SendRecoveryEmail,
    GetLocations,
    // GetUserPermissions,
    GetUserRoles,
    SavePicture,
    DeletePicture,
    NewToken,
} from '@src/services/auth.js'
import roles from '@src/utils/basic-roles.js'
// import { Ability } from '@casl/ability'
var jwtDecode = require('jwt-decode')

export const state = {
    currentUser: getSavedState('auth.currentUser'),
    userLocations: '',
    selectedLocation: getSavedState('auth.selectedLocation'),
}

export const getters = {
    loggedIn(state) {
        return !!state.currentUser
    },
    // ability() {
    //     return new Ability([], {
    //         subjectName(subject) {
    //             return subject
    //         },
    //     })
    // },
}
export const mutations = {
    SET_CURRENT_USER(state, newValue) {
        state.currentUser = newValue
        saveState('auth.currentUser', newValue)
        saveState('auth.token', state.currentUser.token)
    },
    REMOVE_CURRENT_USER(state) {
        state.currentUser = null
        removeState('auth.currentUser')
        removeState('auth.permissions')
        removeState('auth.token')
    },
    SET_USER_LOCATIONS(state, newValue) {
        state.userLocations = newValue
    },
    SET_SELECTED_LOCATION(state, newValue) {
        state.selectedLocation = newValue
        saveState('auth.selectedLocation', newValue)
    },
    REMOVE_SELECTED_LOCATION(state) {
        state.selectedLocation = null
        removeState('auth.selectedLocation')
    },
    CHANGE_IMAGE(state) {
        state.currentUser.picture = ''
    },
    RESET_IMAGE(state) {
        state.currentUser.picture = getSavedState('auth.currentUser').picture
    },
}

export const actions = {
    // init({ rootGetters, dispatch }) {
    //     if (getSavedState('auth.permissions')) {
    //         const ability = rootGetters['auth/ability']
    //         ability.update(getSavedState('auth.permissions').rules)
    //     }
    // },
    async logIn({ commit }, parameters) {
        const resp = await LogInService(parameters)
        if (resp && resp.data && !resp.data.errors && !resp.data.error) {
            const user = jwtDecode(resp.data.data.access_token)
            user.refreshToken = resp.data.data.refresh_token
            user.token = resp.data.data.access_token
            commit('SET_CURRENT_USER', user)
            return { status: true }
        } else {
            const errorMessage = resp.errors ? resp.errors[0] : resp.error
            return { status: false, message: errorMessage }
        }
    },

    logOut({ commit }) {
        commit('REMOVE_CURRENT_USER', null)
        commit('REMOVE_SELECTED_LOCATION', null)
    },

    async getLocations({ commit }, parameters) {
        const resp = await GetLocations(parameters)
        if (resp.status !== 200) return
        commit('SET_USER_LOCATIONS', resp.data.data.items)
        return resp
    },

    async setSelectedLocation({ commit, rootGetters, state }, parameters) {
        commit('SET_SELECTED_LOCATION', parameters)
        // const resp = await GetUserPermissions(state.selectedLocation.publicId)
        // const permissions = {
        //     rules: [
        //         {
        //             subject: 'User',
        //             actions: resp.data.data.map((modules) => {
        //                 if (modules.allowed) return modules.permissionTypeName
        //             }),
        //         },
        //     ],
        // }
        const userPublicId = getSavedState('auth.currentUser').sub
        const locationPublicId = state.selectedLocation.publicId
        const userRolesRequest = await GetUserRoles({
            locationPublicId,
            userPublicId,
        })
        const userRoles = userRolesRequest.data.data.map(
            (role) => roles[role - 1]
        )
        saveState('auth.roles', userRoles)
        // const ability = rootGetters['auth/ability']
        // ability.update(permissions.rules)
        // saveState('auth.permissions', permissions)
    },

    async resetPassword({ _ }, parameters) {
        const resp = await SendRecoveryEmail(parameters)
        return resp.data.success
    },

    async saveProfilePicture({ dispatch }, picture) {
        const resp = await SavePicture(picture)
        if (resp.success) dispatch('requestNewToken')
        return resp
    },

    async deleteProfilePicture({ dispatch }) {
        const resp = await DeletePicture()
        if (resp.status === 200) dispatch('requestNewToken')
        return resp
    },

    changeImage({ commit }) {
        commit('CHANGE_IMAGE')
    },

    resetImage({ commit }) {
        commit('RESET_IMAGE')
    },

    async requestNewToken({ commit }) {
        const params = {
            refreshToken: getSavedState('auth.currentUser').refreshToken,
        }
        const resp = await NewToken(params)
        const user = jwtDecode(resp.data.data.access_token)
        user.refreshToken = resp.data.data.refresh_token
        user.token = resp.data.data.access_token
        commit('SET_CURRENT_USER', user)
    },
}
